import types from './types';
import api from "../api";
import {createError, logError, logSuccess} from "./message";

function requestMasterClassCard() {
  return {
    type: types.GET_MASTER_CLASS_CARD_REQUEST,
    isFetchingMasterClassCard: true
  };
}

function requestMasterClassCardCompleted(masterClassCard) {
  return {
    type: types.GET_MASTER_CLASS_CARD_COMPLETED,
    isFetchingMasterClassCard: false,
    masterClassCard
  };
}

function requestMasterClassCardError(masterClassCardError) {
  return {
    type: types.GET_MASTER_CLASS_CARD_ERROR,
    isFetchingMasterClassCard: false,
    masterClassCardError
  };
}

export function getMasterClassCard(id) {
  return dispatch => {
    dispatch(requestMasterClassCard());
    return api.getMasterClassCard(id)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          //console.log(resp);
          dispatch(requestMasterClassCardCompleted(resp));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestMasterClassCardError(message));
        } else {
          logError(err);
          dispatch(requestMasterClassCardError(createError("Не удалось загрузить карточку мастер класса")));
        }
      });
  };
}

function requestMasterClass() {
  return {
    type: types.GET_MASTER_CLASS_REQUEST,
    isFetchingFullMasterClass: true
  };
}

function requestMasterClassCompleted(masterClassFullInfo) {
  return {
    type: types.GET_MASTER_CLASS_COMPLETED,
    isFetchingFullMasterClass: false,
    masterClassFullInfo
  };
}

function requestMasterClassError(masterClassFullInfoError) {
  return {
    type: types.GET_MASTER_CLASS_ERROR,
    isFetchingFullMasterClass: false,
    masterClassFullInfoError
  };
}

export function getMasterClassFull(id) {
  return dispatch => {
    dispatch(requestMasterClass());
    return api.getMasterClass(id)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestMasterClassCompleted(resp));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestMasterClassError(message));
        } else {
          logError(err);
          dispatch(requestMasterClassError(createError("Не удалось загрузить карточку мастер класса")));
        }
      });
  };
}

function requestMasterClassSystem() {
  return {
    type: types.GET_MASTER_CLASS_SYSTEM_INFO_REQUEST,
    isFetchingMasterClassSystemInfo: true
  };
}

function requestMasterClassSystemCompleted(masterClassSystemInfo) {
  return {
    type: types.GET_MASTER_CLASS_SYSTEM_INFO_COMPLETED,
    isFetchingMasterClassSystemInfo: false,
    masterClassSystemInfo
  };
}

function requestMasterClassSystemError(masterClassSystemInfoError) {
  return {
    type: types.GET_MASTER_CLASS_SYSTEM_INFO_ERROR,
    isFetchingMasterClassSystemInfo: false,
    masterClassSystemInfoError
  };
}

export function getMasterClassSystemInfo(id) {
  return dispatch => {
    dispatch(requestMasterClassSystem());
    return api.getMasterClassSystem(id)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestMasterClassSystemCompleted(resp));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestMasterClassSystemError(message));
        } else {
          logError(err);
          dispatch(requestMasterClassSystemError(createError("Не удалось загрузить карточку мастер класса")));
        }
      });
  };
}

function requestGroupStudents() {
  return {
    type: types.GET_MASTER_CLASS_STUDENTS_REQUEST,
    isFetchingGroupStudents: true
  };
}

function requestGroupStudentsCompleted(groupStudents) {
  return {
    type: types.GET_MASTER_CLASS_STUDENTS_COMPLETED,
    isFetchingGroupStudents: false,
    groupStudents
  };
}

function requestGroupStudentsError(groupStudentsError) {
  return {
    type: types.GET_MASTER_CLASS_STUDENTS_ERROR,
    isFetchingGroupStudents: false,
    groupStudentsError
  };
}

export function getMasterClassStudents(id) {
  return dispatch => {
    dispatch(requestGroupStudents());
    return api.getMasterClassStudents(id)
      .then(response => {
        if (response.status === 200) {
          const students = (response.data && response.data.students) ? response.data.students : [];
          dispatch(requestGroupStudentsCompleted(students));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestGroupStudentsError(message));
        } else {
          logError(err);
          dispatch(requestGroupStudentsError(createError("Не удалось загрузить состав группы")));
        }
      });
  };
}

function requestMasterClassListByProgram() {
  return {
    type: types.GET_MASTER_CLASSES_BY_PROGRAM_REQUEST,
    isFetchingMasterClassByProgram: true
  };
}

function requestMasterClassListByProgramCompleted(masterClassListByProgram) {
  return {
    type: types.GET_MASTER_CLASSES_BY_PROGRAM_COMPLETED,
    isFetchingMasterClassByProgram: false,
    masterClassListByProgram
  };
}

function requestMasterClassListByProgramError(masterClassListByProgramError) {
  return {
    type: types.GET_MASTER_CLASSES_BY_PROGRAM_ERROR,
    isFetchingMasterClassByProgram: false,
    masterClassListByProgramError
  };
}

export function getMasterClassListByProgram(id) {
  return dispatch => {
    dispatch(requestMasterClassListByProgram());
    return api.getMasterClassListByProgram(id)
      .then(response => {
        if (response.status === 200) {
          const resp = response.data;
          dispatch(requestMasterClassListByProgramCompleted(resp));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestMasterClassListByProgramError(message));
        } else {
          logError(err);
          dispatch(requestMasterClassListByProgramError(createError("Не удалось загрузить список мастер классов")));
        }
      });
  };
}

export default {
  getMasterClassSystemInfo,
  getMasterClassCard,
  getMasterClassFull,
  getMasterClassStudents,
  getMasterClassListByProgram
}
